// Module
var code = "<div class=\"width-100\"> <wt-select changed=\"vm.onGroupChange(value)\" disable-translate=\"true\" model=\"vm.selectedGuid\" placeholder=\"{{'Select a group'|translate}}\" properties=\"vm.groups\"> </wt-select> </div>";
// Exports
module.exports = code;